import {Component, Input, OnInit} from '@angular/core';
import {Card} from '../../../../model/cards';

@Component({
  selector: 'app-image-slider',
  imports: [],
  templateUrl: './image-slider.component.html',
  standalone: true,
  styleUrl: './image-slider.component.scss'
})
export class ImageSliderComponent implements OnInit{
  @Input() card: Card = new Card({
    img: '',
    button: false,
    text: [],
    title: [],
    style: '',
  });
  alt: string = 'img'


  ngOnInit() {}

  getImgStyle() {
    const objectFit = this.card.cssStyle?.split(';')
      .filter(item => item.trim() !== '')
      .find(v => v.includes('object-position:')) ?? '';
    switch (this.card.position) {
      case 'vertical': {
        return 'height: 85%;' + objectFit;
      }
      case 'horizontal': {
        return 'height: 50%; width: 100%;' + objectFit;
      }
    }
    return '';
  }
}
